seedWebApp.controller('SentEmailsController', ['$scope', '$uibModal', '$rootScope', 'LogisticsService', 'ToastService', 'StoreService',
    function ($scope, $uibModal, $rootScope, LogisticsService, ToastService, StoreService) {

        $scope.prefs = {
            name: 'SentEmailsGrid',
            sortByCol: null,
            canAdd: false,
            canEdit: true,
            canDelete: false,
            parentFilter: {},
            canSelect: true,
            disableLoadItems: true,
        };

        $scope.loadService = LogisticsService.getSentEmails;
        $scope.loadColumns = LogisticsService.getSentEmailsColumns;
        $scope.resetService = LogisticsService.resetCache;

        $scope.getCountClass = function (item) {
            return 'qt-pos';
            //return 'qt-orders';
        };

        $scope.dateFormat = "MMM dd, yyyy HH:mm";
        $scope.dateOnly = "MMM dd, yyyy";
        $scope.columns = [
            { name: 'SendUserID', display: 'User', width: 1, filterOptions: [], dataType: 'avatar' },
            { name: 'SentEmailID', display: '#Id', width: 1 },
            { name: 'SendDate', display: 'Send Date', dataType: 'date', format: $scope.dateFormat, isUTC: true, width: 5, filterOptions: [] },
            { name: 'EmailID', display: '#Email', width: 1, filterOptions: [] },
            { name: 'EmailName', display: 'Email', width: 5 },
            { name: 'VesselNames', display: 'Vessel Names', width: 5 },            
            { name: 'ContactIDs', display: 'Contacts', width: 5 },            
            { name: 'ShippingDate', display: 'ShippingDate', width: 5, dataType: 'date', format: $scope.dateOnly, isUTC: false },                        
            //{ name: 'EmailSubject', display: 'Subject', width: 5 },            
            { name: 'EmailRecipients', display: 'Recipients', width: 5 },
            { name: 'EmailDocTypes', display: 'Documents', width: 5 },            
            { name: 'OrderCount', display: 'Orders', width: 1, customClass: $scope.getCountClass },
            { name: 'Orders', display: 'Orders', width: 5, dataType: 'tags', tagLimit: 10 },            
        ];

        $scope.prefs.customEdit = function (item) {
            //$scope.editItem(item);
            console.log('modal');

            var modalInstance = $uibModal.open({
                templateUrl: './SPA/logistics/sentEmailModal.html' + seedWebApp.buildVersion,
                controller: 'SentEmailModalCtrl',
                size: 'xl',
                resolve: {
                    sentEmailID: function () {
                        return item.SentEmailID;
                    },    
                    item: function () {
                        return item;
                    },    
                }
            });
            return modalInstance;
        };

        $scope.editItem = function (item) {
            StoreService.openOrderDetailModal(item.OrderID, null);
        };

        $scope.doInsert = function () {
            $scope.editItem(null);
        };

        $scope.searchMode = function () {
            $scope.$broadcast('inputSearch', $scope.filterString);
        };

        $scope.doRefresh = function () {
            $scope.selectedCount = 0;
            $scope.$broadcast('refreshServiceGrid');
            //$rootScope.$broadcast('delete_filter', null);
        };

    }
]);